import { Environment } from '@env/environment.interface';

export const environment: Environment = {
    production: true,
    deploymentEnvironment: 'development',
    pwa: true,
    url: {
        backendApi: 'https://api2.hyponamiru.dev',
        bankLogos: '/assets/providers/',
        smsBackendApi: 'https://sms.hyponamiru.dev',
        bankingUrl: 'https://moje.hyponamiru.dev',
    },
    captchaEnabled: true,
    captchaSiteKey: '6Lf7pDUqAAAAAPMDnAT8xUPr6SnuBhhM0OVyyZsp',
    title: 'bankovnictví hyponamiru.cz',
    calculatorProducts: {
        refinancing: {
            simple: {
                title: '',
                logo: '',
                extraGroups: false,
                groups: {
                    basic: {
                        title: 'Hypoteční úvěr',
                        type: 'basic',
                        items: {
                            rate: {
                                name: 'rate',
                                title: 'Úrok',
                                type: 'percent',
                            },
                            repayment: {
                                name: 'repayment',
                                title: 'Splátka',
                                type: 'repayment',
                            },
                            maturity: {
                                name: 'maturity',
                                title: 'Splatnost',
                                type: 'year',
                            },
                            amount: {
                                name: 'amount',
                                title: 'Výše úvěru',
                                type: 'money',
                            },
                        },
                    },
                },
            },
        },
    },
};
